'use es6';

export var accountId = 53;
export var debugKey = 'USAGE_TRACKER_JS';
export var hstcKey = '__hstc';
export var hamplitudeKey = '__hmpl';
export var storageKey = "HUBLYTICS_EVENTS_" + accountId;
export var recorderEnabled = 'USAGE_TRACKER_JS_RECORDER_ENABLED';
export var recordedEvents = 'USAGE_TRACKER_JS_RECORDED_EVENTS';
export var recordedEventKeys = 'USAGE_TRACKER_JS_RECORDED_EVENT_KEYS';